import React, { createContext } from "react";

const MarketQuizzContext = React.createContext();

export default MarketQuizzContext;
